import React, {useEffect, useState} from 'react';
import {useForm} from 'react-hook-form';
import './clientForm.scss';
import {getLanguageById} from '../../../helpers/language';
import SearchLocationInput from '../../../components/SearchLocationInput';
import {withTranslation} from 'react-i18next';
import {DeliveryType} from '../../../constants/deliveryTypes';
import Switch from 'react-ios-switch';
import {isMobileAndTablet} from '../../../helpers/common';
import {useHistory} from 'react-router-dom';
import AreasService from '../../../services/areas.service';
import {setCostDelivery} from '../../../redux/actions/costDeliveryActions';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import IPosModal from '../../../IPosModal';
import {loadRestaurant} from '../../../redux/actions/baseActions';

function* range(start, end, step) {
  while (start < end) {
    yield start;
    start += step;
  }
}

const ClientInfoForm = ({
                          formData,
                          formSubmit,
                          t,
                          currentDeliveryType,
                          branchInfo,
                          setCostDelivery,
                          loadRestaurant,
                          currentTableId
                        }) => {
  const {register, handleSubmit, watch, errors, clearErrors, setError} = useForm({
    defaultValues: formData
  });

  const isMobile = isMobileAndTablet();
  const history = useHistory();

  const [isAddressValid, setIsAddressValid] = useState(formData.address !== null);
  const [utensils, setUtensils] = useState(formData.utensils);
  const [errorTerms, setErrorTerms] = useState(false);
  const [termsOfService, setTermsOfService] = useState(formData.termsOfService);
  const [clientMobile, setClientMobile] = useState(formData.clientMobile);
  const [clientEmail, setClientEmail] = useState(formData.clientEmail);
  const [addressArea, setAddressArea] = useState(formData.addressArea);

  const [selectedAddress, setSelectedAddress] = useState(formData.address);

  useEffect(() => {
    if (!addressArea) {
      setCostDelivery(null);
      return;
    }

    const deliveryPrice = (addressArea === 'undefine' || !addressArea) ? 0 : addressArea.delivery_price;
    setCostDelivery(+deliveryPrice);

  }, [addressArea]);

  const onChangeClientMobile = (e) => {
    const {value} = e.currentTarget;
    const max = 10;
    const currentLength = value.length;
    // const maxLength = max.toString().length-1;
    setClientMobile(currentLength < max ? value : value.toString().substring(0, max));
  };

  const onChangeClientEmail = (e) => {
    const {value} = e.currentTarget;

    if (value === '' || /^[0-9A-Za-z,@,.,+,-]+[A-Za-z0-9,@,.,+,-]*$/.test(value)) {
      setClientEmail(value);
      // clearErrors('clientEmail')
    }
  };

  const onSelectAddress = (addressData) => {
    if (!addressData) {
      return;
    }

    const address = {
      formatted_address: addressData.formatted_address,
      lat: addressData.geometry.location.lat(),
      lng: addressData.geometry.location.lng(),
      place_id: addressData.place_id
    };

    setIsAddressValid(true);
    setSelectedAddress(address);

    AreasService.validateAddress(addressData, branchInfo.branch_guid_code)
      .then((res) => {
        if (res) {
          setAddressArea(res);
        } else {
          IPosModal.alert({
            title: '',
            message: t('dialogs.not_supported_area_error'),
            okButtonText: t('buttons.ok'),
            cancelButtonText: t('buttons.cancel'),
            onOk: () => {
            }
          });
        }
      });
  };

  const onSubmit = async (data) => {

    if (!termsOfService) {
      setErrorTerms(true);
      // IPosModal.alert({
      //   title: '',
      //   message: t('dialogs.terms_of_service_not_check'),
      //   okButtonText: t('buttons.ok'),
      //   onOk: () => {
      //   }
      // });

      return;
    }

    const currentBranchState = await loadRestaurant(branchInfo.branch_guid_code);

    if ([DeliveryType.DELIVERY, DeliveryType.TA, DeliveryType.EAT_IN].includes(currentDeliveryType) && !currentBranchState.IsWorkingDelivery) {
      IPosModal.alert({
        title: '',
        message: t('dialogs.not_accepting_orders'),
        okButtonText: t('buttons.ok'),
        onOk: () => {
        }
      });

      return;
    }    

    if ((!isAddressValid || !addressArea) && currentDeliveryType === DeliveryType.DELIVERY) {
      IPosModal.alert({
        title: '',
        message: t('dialogs.not_supported_area_error'),
        okButtonText: t('buttons.ok'),
        cancelButtonText: t('buttons.cancel'),
        onOk: () => {
        }
      });
      return;
    }
    console.log(data);
    formSubmit({...data, ...{address: selectedAddress, utensils}});
  };

  const validateEmail = (email) => {
    const re = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;
    return re.test(email);
  };

  const hasRequiredFields = true;//!(currentTableId && currentDeliveryType === DeliveryType.EAT_IN);
  const emailRequired = currentDeliveryType !== DeliveryType.EAT_IN;

  return (
    <div className={"client-info-block"}>
      <h3 className="headline">
        <span>
          {t("client_details.title")}
          {!hasRequiredFields && (
            <span className={"optional-title"}>
              ({t("client_details.optional")})
            </span>
          )}
        </span>
      </h3>
      <form className={"client-form"} onSubmit={handleSubmit(onSubmit)}>
        {currentDeliveryType === DeliveryType.DELIVERY && (
          <>
            <div
              className={`form-input ${hasRequiredFields ? "required" : ""} `}
            >
              <label htmlFor="address">{t("client_details.address")}</label>

              <SearchLocationInput
                placeholder={t("client_details.address_placeholder")}
                language={getLanguageById(2)}
                defaultValue={
                  formData.address ? formData.address.formatted_address : ""
                }
                addressObject={formData.address}
                onAddressSelect={onSelectAddress}
              />

              {/*{ !isAddressValid &&*/}
              {/*<div className={'input-error'}>*/}
              {/*  <span>{ t('client_details.validation.required_field') }</span>*/}
              {/*</div>*/}
              {/*}*/}
            </div>

            <div className={"form-input"}>
              <label htmlFor="apartment">{t("client_details.apartment")}</label>
              <input
                type="number"
                name="apartment"
                autoComplete={"off"}
                placeholder={t("client_details.apartment")}
                ref={register({ pattern: /^[0-9]\d*$/i })}
              />
            </div>
            <div className={"form-input"}>
              <label htmlFor="flor">{t("client_details.flor")}</label>
              <input
                type="number"
                name="flor"
                autoComplete={"off"}
                placeholder={t("client_details.flor")}
                ref={register({ pattern: /^[0-9]\d*$/i })}
              />
            </div>

            <div className={"form-input"}>
              <label htmlFor="addressNote">
                {t("client_details.address_note")}
              </label>
              <textarea
                name="addressNote"
                ref={register}
                placeholder={t("client_details.address_note_placeholder")}
              />
            </div>
          </>
        )}

        <div className={`form-input ${hasRequiredFields ? "required" : ""} `}>
          <label htmlFor="clientName">{t("client_details.name")}</label>
          <input
            type="text"
            name="clientName"
            autoComplete={"off"}
            placeholder={t("client_details.name_placeholder")}
            ref={register({ required: hasRequiredFields })}
          />
          {errors.clientName && (
            <div className={"input-error"}>
              <span>{t("client_details.validation.invalid_name")}</span>
            </div>
          )}
        </div>

        <div className={`form-input ${hasRequiredFields ? "required" : ""} `}>
          <label htmlFor="clientMobile">{t("client_details.mobile")}</label>
          <input
            type="number"
            name="clientMobile"
            maxLength={10}
            onChange={onChangeClientMobile}
            value={clientMobile}
            autoComplete={"off"}
            ref={register({
              required: hasRequiredFields,
              maxLength: 10,
              minLength: {
                value: 10,
                message: "error message",
              },
              pattern: /^[0-9]\d*$/i,
            })}
            placeholder={t("client_details.mobile_placeholder")}
          />
          {errors.clientMobile && (
            <div className={"input-error"}>
              {errors.clientMobile.type === "required" && (
                <span>{t("client_details.validation.invalid_mobile")}</span>
              )}

              {errors.clientMobile.type === "minLength" && (
                <span>
                  {t("client_details.validation.min_length", { minLength: 10 })}
                </span>
              )}
            </div>
          )}
        </div>

        <div
          className={`form-input ${
            branchInfo.use_pin_pad_flg !== 1 && emailRequired ? "required" : ""
          }`}
        >
          <label htmlFor="clientEmail">{t("client_details.email")}</label>
          <input
            type="email"
            name="clientEmail"
            className={"client-email"}
            autoComplete={"off"}
            ref={register({
              //required: branchInfo.use_pin_pad_flg !== 1 && emailRequired,
              pattern: /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i,
            })}
            value={clientEmail}
            placeholder={t("client_details.email_placeholder")}
            onChange={onChangeClientEmail}
          />

          {errors.clientEmail && (
            <div className={"input-error"}>
              <span>{t("client_details.validation.invalid_email")}</span>
            </div>
          )}
        </div>

        <div className={"form-input"}>
          <label htmlFor="orderNote">{t("client_details.order_note")}</label>
          <textarea
            name="orderNote"
            ref={register}
            placeholder={t("client_details.order_note_placeholder")}
          />
        </div>

        {hasRequiredFields && (
          <div className={"form-input"}>
            <label htmlFor="Utensils">{t("client_details.utensils")}</label>
            <Switch
              checked={utensils}
              ref={register}
              className={""}
              handleColor="white"
              name={"utensils"}
              offColor="white"
              onChange={setUtensils}
              onColor="#0082c8"
              // pendingOffColor={undefined}
              // pendingOnColor={undefined}
              // readOnly={undefined}
              // style={undefined}
            />
          </div>
        )}

        {utensils && (
          <div className={"form-input"}>
            <label htmlFor="dinersQty">{t("client_details.diners_qty")}</label>
            <select
              className={""}
              name={"dinersQty"}
              ref={register({ required: hasRequiredFields })}
            >
              {Array.from(range(1, 9, 1)).map((number) => (
                <option value={number}>{number}</option>
              ))}
            </select>
          </div>
        )}

        <div className={"form-input"}>
      
        {errorTerms  && <label htmlFor="termsOfService" style={{ color: 'red' }}>{t("client_details.approve")}
              <a href="https://www.ipos.co.il/privacy-terms-service" target="_blank" rel="noopener noreferrer" style={{ color: 'red' }}>
                {t("client_details.terms")}
              </a>
          </label>
                        }
        {!errorTerms  && <label htmlFor="termsOfService" >{t("client_details.approve")}
              <a href="https://www.ipos.co.il/privacy-terms-service" target="_blank" rel="noopener noreferrer">
                {t("client_details.terms")}
              </a>
          </label>
                        }
          <Switch
            checked={termsOfService}
            ref={register}
            className={""}
            handleColor="white"
            name={"termsOfService"}
            offColor="white"
            onChange={(e) => {
              setTermsOfService(!termsOfService);
              setErrorTerms(false);
            }}
            onColor="#0082c8"            
          />
        </div>

        <div className={"actions"}>
          {
            <input
              className="button-back"
              type="button"
              value={t("buttons.back")}
              onClick={() => {
                history.push(`/${branchInfo.branch_guid_code}/order`);
              }}
            />
          }

          <input type="submit" value={t("client_details.pay_btn")} />
        </div>
      </form>
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    currentTableId,
    currentDeliveryType
  } = state;

  return {
    currentTableId,
    currentDeliveryType
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setCostDelivery,
      loadRestaurant
    },
    dispatch,
  );
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ClientInfoForm));
